import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { useDisplayCurrency, SUPPORTED_CURRENCIES, CURRENCY_LABELS } from "@/context/CurrencyContext";
import { Check, ChevronDown, Globe2, MapPin } from "lucide-react";

const SYMBOL = { USD: "$", EUR: "€", AUD: "A$", CAD: "C$", INR: "₹" };

export function CurrencyToggle({ variant = "light" }) {
  const { currency, setCurrency, autoDetected } = useDisplayCurrency();
  const light = variant === "light";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={`rounded-full px-3 gap-1.5 ${light ? "text-[#0B192C] hover:bg-[#F3EFEA]" : "text-white/80 hover:bg-white/10"}`}
          data-testid="currency-toggle"
          title={autoDetected ? "Auto-detected from your location" : "Chosen manually"}
        >
          {autoDetected ? <MapPin className="h-3.5 w-3.5 text-[#0F5132]" /> : <Globe2 className="h-3.5 w-3.5" />}
          <span className="font-mono text-xs tracking-wider">{SYMBOL[currency]} {currency}</span>
          <ChevronDown className="h-3 w-3 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel className="overline text-[10px]">
          Display currency
          {autoDetected && (
            <span className="ml-2 inline-flex items-center gap-1 text-[9px] text-[#0F5132] normal-case tracking-normal font-medium" data-testid="currency-auto-badge">
              <MapPin className="h-2.5 w-2.5" />auto-detected
            </span>
          )}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {SUPPORTED_CURRENCIES.map((c) => (
          <DropdownMenuItem
            key={c}
            onClick={() => setCurrency(c)}
            className="cursor-pointer justify-between"
            data-testid={`currency-option-${c}`}
          >
            <span className="flex items-center gap-2">
              <span className="font-mono w-6 text-[#8B6B2E]">{SYMBOL[c]}</span>
              <span>{c}</span>
              <span className="text-xs text-slate-500">— {CURRENCY_LABELS[c]}</span>
            </span>
            {currency === c && <Check className="h-4 w-4 text-[#0F5132]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
